// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBsJjbPLPjtm4i9GkR0n-d1rXyF4Ng31Yw",
  authDomain: "affable-operand-306405.firebaseapp.com",
  projectId: "affable-operand-306405",
  storageBucket: "affable-operand-306405.appspot.com",
  messagingSenderId: "472320300273",
  appId: "1:472320300273:web:f1ac254352fef104380550",
  measurementId: "G-79BLGR24Z2",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
